import React from "react";
import { useRoutes } from "react-router-dom";
import MainLayout from "../views/layouts/MainLayout";
import TrialLayout from "../views/layouts/TrialLayout";
import AuthLayout from "../views/layouts/AuthLayout";
import PageNotFound from "../views/errors/PageNotFound";
import WebLogin from "../views/webPages/Loginpages/webLogin/WebLogin";
import WebLoginThink from "../views/webPages/Loginpages/webLoginThink/WebLoginThink";
import Register from "../views/webPages/Loginpages/Register/Register";
import ForgotPasswordWeb from "../views/webPages/Loginpages/ForgotPassword/ForgotPassword";
import UserProfile from "../views/webPages/WebDashBoard/Components/UserProfile/UserProfile";
import ChangePassword from "../views/webPages/Loginpages/ChangePassword/ChangePassword";
import Cmspages from "../views/webPages/CmsPages/Index";
import VRTrainingLocation from "../views/webPages/WebDashBoard/Components/VRTrainingLocation/VRTrainingLocation";
import InterestAssessmentView from "../views/webPages/WebDashBoard/Components/InterestAssessment/InterestAssessmentView";
import SkillAssessmentView from "../views/webPages/WebDashBoard/Components/SkillAssessment/SkillAssessmentView";
import InterestAssessmentPending from "../views/webPages/WebDashBoard/Components/InterestAssessment/InterestAssessmentPending";
import SkillAssessmentPending from "../views/webPages/WebDashBoard/Components/SkillAssessment/SkillAssessmentPending";
import Result from "../views/webPages/WebDashBoard/Components/Result/Result";
import AllCareers from "../views/webPages/WebDashBoard/Components/AllCareers";
import SavedJobs from "../views/webPages/WebDashBoard/Components/SavedJobs/SavedJobs";
import Acronyms from "../views/webPages/WebDashBoard/Components/Acronyms";
import Resources from "../views/webPages/WebDashBoard/Components/Resources";
import ModuleWrap from "../components/ModuleWrap";
import CareerDetailsPage from "../views/webPages/WebDashBoard/Components/AllCareers/Detail/CareerDetailsPage";
import EnergyIndustries from "../views/webPages/WebDashBoard/Components/EnergyIndustries";
import TrainingCredentials from "../views/webPages/WebDashBoard/Components/TrainingCredentials";
import EnergyIndustriesDetails from "../views/webPages/WebDashBoard/Components/EnergyIndustries/Details";



import * as MiniResult from "../views/webPages/MiniEcn/Components/Result/Result";
import * as MiniIntrestPending from "../views/webPages/MiniEcn/Components/InterestAssessment/InterestAssessmentPending";


export default function Router() {
    return useRoutes(RouterConfig);
}

export const RouterConfig = [
    {
        path: '/',
        element: <AuthLayout />,
        children: [
            {
                path: "about-us",
                element: <ModuleWrap module={Cmspages} />
            },
            {
                path: "terms-of-use",
                element: <ModuleWrap module={Cmspages} />
            },
            {
                path: "privacy-policy",
                element: <ModuleWrap module={Cmspages} />
            },
            {
                path: "",
                element: <ModuleWrap module={Register} />,
            },

            {
                path: "login",
                element: <ModuleWrap module={WebLogin} />,
            },
             {
                path: "thinkific-login",
                element: <ModuleWrap module={WebLoginThink} />,
            },
            {
                path: "register",
                element: <ModuleWrap module={Register} />,
            },
            {
                path: "forgot-password",
                element: <ModuleWrap module={ForgotPasswordWeb} />,
            },
            {
                path: "register/:user_id",
                element: <ModuleWrap module={Register} />,
            },
            {
                path: "register/link/:access_code_id",
                element: <ModuleWrap module={Register} />,
            },

            {
                path: "reset/:otp",
                element: <ModuleWrap module={ChangePassword} />,
            },
        ]
    },

    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: "/dashboard",
                element: <ModuleWrap module={Result} />,
            },
            {
                path: "/user-profile",
                element: <ModuleWrap module={UserProfile} />,

            },
            {
                path: "/locations",
                element: <ModuleWrap module={VRTrainingLocation} />,
            },
            {
                path: "/interest-assessment-exam/:id",
                element: <ModuleWrap module={InterestAssessmentView} />,
            },
            {
                path: "/interest-assessment-exam-pending/:id",
                element: <ModuleWrap module={InterestAssessmentPending} />,
            },

            {
                path: "/skill-assessment-exam/:id",
                element: <ModuleWrap module={SkillAssessmentView} />,
            },
            {
                path: "/skill-assessment-exam-pending/:id",
                element: <ModuleWrap module={SkillAssessmentPending} />,
            },
            // {
            //     path: "/report",
            //     element: <ModuleWrap module={Result} />,
            // },
            {
                path: "/careers",
                element: <ModuleWrap module={AllCareers} />,
            },
            {
                path: "/careers/:career_category",
                element: <ModuleWrap module={AllCareers} />,

            },
            {
                path: "/careers/details/:careerId",
                // element: <CareerDetailsPage />,
                element: <ModuleWrap module={CareerDetailsPage} />,
            },
            {
                path: "/saved-careers",
                element: <ModuleWrap module={SavedJobs} />,
            },
            {
                path: "/acronyms",
                element: <ModuleWrap module={Acronyms} />,
            },
            {
                path: "/resources",
                element: <ModuleWrap module={Resources} />,
            },
            {
                path: "/energy-industries",
                element: <EnergyIndustries />,
            },
            {
                path: "/energy-industries-details/:id",
                element: <EnergyIndustriesDetails />,
            },
            {
                path: "/training-credentials",
                element: <TrainingCredentials />,
            }


        ],
    },
    {
        path: '/trial/',
        element: <TrialLayout />,
        children: [
            {
                path: "dashboard",
                element: <ModuleWrap module={MiniResult.default} />,
            },
            {
                path: "user-profile",
                element: <ModuleWrap module={UserProfile} />,

            },
            {
                path: "interest-assessment-exam-pending/:id",
                element: <ModuleWrap module={MiniIntrestPending.default} />,
            },

        ]
    },
    {
        path: "*",
        element: <PageNotFound />,
    },
];
